@if (!userResource.error()) {
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'USER_NOTIFICATIONS.MESSAGE_TITLE' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'USER_NOTIFICATIONS.SUBTITLE_FIRST_LINE' | translate }}</mat-card-subtitle>
    </mat-card-header>
  </mat-card>
  @if (userResource.value(); as user) {
    <div class="global-toggle">
      <mat-slide-toggle
        class="example-margin"
        [checked]="allNotificationsEnabled()"
        (change)="toggleGlobalNotifications(user, $event.checked)"
      >
        {{ 'USER_NOTIFICATIONS.ALL_NOTIFICATIONS' | translate }}
      </mat-slide-toggle>
    </div>
  }
  @if (userResource.value(); as user) {
    <div class="table-container mat-elevation-z0">
      <div class="table-header">
        <va-search-box class="search" (update)="search($event)"></va-search-box>
      </div>
      @if (!partnerNotificationEnabled()) {
        <glxy-alert
          type="error"
          [showAction]="true"
          [actionTitle]="'USER_NOTIFICATIONS.PARTNER_NOTIFICATIONS_DISABLED_ACTION' | translate"
          (actionClick)="onConfigurePartnerNotificationActionClick()"
        >
          {{ 'USER_NOTIFICATIONS.PARTNER_NOTIFICATIONS_DISABLED' | translate }}
        </glxy-alert>
      } @else if (!allNotificationsEnabled()) {
        <glxy-alert type="error">
          {{ 'USER_NOTIFICATIONS.ALL_NOTIFICATIONS_DISABLED_FOR_USER' | translate }}
        </glxy-alert>
      }

      <table mat-table [dataSource]="associatedAccountGroupsPage$" [trackBy]="trackById">
        <!-- Name & Address -->
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <div class="company-name">
              @if (row.accountGroupId !== '') {
                <a [routerLink]="['/businesses/accounts', row.accountGroupId, 'details']">
                  {{ row.napData.companyName }}
                </a>
              } @else {
                <div class="user-global-notification">
                  {{ row.napData.companyName }}
                  <mat-icon
                    [glxyTooltip]="'USER_NOTIFICATIONS.GLOBAL_SETTING_TOOLTIP' | translate"
                    [tooltipPositions]="positions"
                  >
                    help_outline
                  </mat-icon>
                </div>
              }
            </div>
            <div class="address subtitle">
              {{ address(row) }}
            </div>
          </td>
        </ng-container>

        <!-- Expanded indicator -->
        <ng-container matColumnDef="indicator">
          <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
          <td mat-cell class="subtitle toggle-container" *matCellDef="let row">
            <mat-icon [@indicatorRotate]="getExpandedState(row.accountGroupId)" class="toggle-table">
              keyboard_arrow_down
            </mat-icon>
          </td>
        </ng-container>

        <!-- Data -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="element-row"
          [appDetailRow]="row"
          [appDetailRowTpl]="tpl"
          (opened)="panelOpen(row.accountGroupId)"
          (closed)="panelClose(row.accountGroupId)"
        ></tr>
      </table>
      <div class="table-information" *ngIf="loadingAccountGroups$ | async">
        <mat-spinner [strokeWidth]="6" [diameter]="48"></mat-spinner>
      </div>
      <div class="table-footer">
        <mat-paginator
          [length]="total$ | async"
          [pageSize]="pageSize$ | async"
          [pageIndex]="pageIndex$ | async"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="paginationChange($event)"
        ></mat-paginator>
      </div>
    </div>
  } @else {
    <store-list-stencil></store-list-stencil>
  }
} @else {
  <mat-card appearance="outlined">
    {{ 'USER_NOTIFICATIONS.FAILED_TO_LOAD_USER' | translate }}
    <div class="error-details">
      {{ userResource.error() }}
    </div>
  </mat-card>
}
<ng-template #tpl let-element>
  <tr class="notifications-row" [@detailExpand]>
    <td colspan="2">
      <app-legacy-notification-preference
        [partnerId]="partnerId"
        [marketId]="element.externalIdentifiers.marketId"
        [accountGroupId]="element.accountGroupId"
        [userId]="unifiedUserId()"
      ></app-legacy-notification-preference>
    </td>
  </tr>
</ng-template>
